<template>

  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex-grow flex flex-col container mx-auto bg-white rounded p-2 ">
            <div class="flex-shrink-0 flex items-center justify-between w-full h-10 mb-4 rounded">
              <div class="w-full bg-primary p-2 rounded">
                <span class="text-xl">Einkaufsbereich </span>
              </div>
            </div>

            <div class="flex-grow flex flex-col space-y-4 overflow-auto">

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Name</span>
                <input class="border p-2 rounded w-full " data-ui="name" v-model="team.name">
              </div>

              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Beschreibung</span>
                <input class="border p-2 rounded w-full " data-ui="teamIcon" v-model="team.teamIcon">
              </div>


              <div class="flex space-x-2">
                <span class="bg-primary w-[200px] p-2 rounded">Farbe</span>
                <div class="w-full bg-trader-gray p-2 rounded">
                  <input type="color" class="border rounded w-full " data-ui="team-color" v-model="team.color">
                </div>

              </div>

              <button
                  class="w-full rounded mt-2 p-3 bg-primary hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                  @click="editPurchaser" data-ui="save-changes">
                Speichern
              </button>
              <button
                  class="w-full rounded mt-2 p-3 bg-trader-red hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out"
                  @click="deleteTrue" data-ui="delete-ekb">
                Löschen
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <sidebar/>

  </div>
</template>

<script>
import sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SignalBus from "@/application/SignalBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, sidebar},
  data() {
    return {
      teamID: 0,
      newTeamID: null,
      team: {
        getPurchaserByID: "",
      },
      accordionIndex: 0,
    }

  },

  methods: {
    deleteTrue() {
      eventBus.openConfirm({
        title: "Einkaufsbereiche",
        message: "Möchten Sie diesen Einkaufsbereiche wirklich löschen?",
        onAccept: () => {
          this.deletePurchaser();
        }
      });
    },
    goBack() {
      router.push(`/administration`);
    },
    async editPurchaser() {
      const teamData = {
        id: this.teamID,
        name: this.team.name,
        icon: this.team.teamIcon,
        color: this.team.color.replace('#', ''),
      };

      const mutation = gql`
        mutation editTeam($team: TeamInputEdit!) {
          editTeam(team: $team) {
            success
          }
        }
      `;

      try {
        const variables = {
          team: teamData
        };

        const {data} = await apolloClient.mutate({mutation, variables});
        SignalBus.emit("sidebar-update-purchaser");
        if (data.editTeam.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Einkaufsbereich gespeichert",
            message: "Der Einkaufsbereich wurde gespeichert.",
          });
        }

      } catch (error) {
        console.error("Daten konnten nicht geUpdatet werden ", error);
      }

    },
    async deletePurchaser() {

      const mutation = gql`
        mutation deletePurchaser($purchaserId: Int!) {
          deletePurchaser(purchaserId: $purchaserId) {
            success
          }
        }
      `;

      try {
        const variables = {
          purchaserId: this.teamID
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.deletePurchaser.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Einkaufsbereich gelöscht",
            message: "Der Einkaufsbereich wurde gelöscht",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch
          (error) {
        console.error(error);
      }

    }
    ,
    async getPurchaserByID(teamID) {

      try {
        const response = await apolloClient.query({
          query: gql`
                query getPurchaserByID($teamID: Int!) {
                       getPurchaserByID(teamID: $teamID) {
                        id
                        name
                        teamIcon
                        color
                    }
                }
            `,
          variables: {
            teamID: this.teamID
          }
        });
        const getPurchaserByID = response.data.getPurchaserByID;
        this.team.name = getPurchaserByID.name;
        this.team.teamIcon = getPurchaserByID.teamIcon;
        this.team.color = getPurchaserByID.color;

      } catch (error) {
        console.error("Fehler beim Abrufen der teamDaten:", error);
      }
    }
    ,
  },
  mounted() {
    this.getPurchaserByID();
    this.newTeamID = this.$route.params.teamId;
  },
  watch: {
    '$route.params.teamId': function (newId) {
      this.teamID = newId;
      this.getPurchaserByID(this.teamID); // Rufen Sie die Methode auf, um Daten basierend auf der neuen ID zu holen
    },
    '$route.params': function (newParams, oldParams) {
      this.teamID = newParams.teamID;
    }
  },
  created() {
    if (this.$route.params.teamId != null && typeof this.$route.params.teamId != 'undefined' && this.$route.params.teamId != '') {
      this.teamID = this.$route.params.teamId;
      this.getPurchaserByID(this.teamID)
    }
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>

